import config from "../config";

function isLdFlagEnabled(flags: Record<string, unknown>, ...keys: string[]): boolean {
  for (const key of keys) {
    const value = flags[key];
    if (value === true) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true" || normalized === "on" || normalized === "yes" || normalized === "1") {
        return true;
      }
    }
  }
  return false;
}

const RMM_ALERTS_FLAG_KEYS = ["rmm-alerts", "rmmAlerts", "rmmalerts"];

export function isRmmAlertsLdEnabled(flags: Record<string, unknown>): boolean {
  if (process.env.NODE_ENV === "development" && !config.launchdarklyClientSideId) {
    return true;
  }
  return isLdFlagEnabled(flags, ...RMM_ALERTS_FLAG_KEYS);
}
